import _ from 'lodash';
import validator from 'validator'; // https://github.com/chriso/validator.js/tree/3.41.3
import IBAN from 'iban';

const INSURER_KEYS = {
  '11': 'die Bayerische',
  AC: 'ADAC Autoversicherung',
  AL: 'Alte Leipziger',
  AM: 'AachenMünchener',
  AT: 'Asstel',
  AX: 'AXA',
  AY: 'AXA easy',
  A1: 'Allianz',
  AF: 'Allianz',
  AZ: 'Allianz',
  B4: 'Basler',
  B6: 'Bavaria Direkt',
  BB: 'BGV',
  BU: 'Bruderhilfe / VRK',
  BV: 'Versicherungskammer Bayern',
  BZ: 'Barmenia',
  CA: 'Condor',
  CC: 'Concordia',
  CD: 'Cosmos Direkt',
  CS: 'Continentale',
  D1: 'DA Direkt',
  DD: 'Sparkassen-Versicherung Sachsen',
  DE: 'Debeka',
  DL: 'Direct Line',
  EM: 'EMIL',
  ES: 'Europa',
  FD: 'Friday',
  G1: 'DEVK',
  G3: 'Garanta',
  GA: 'Gothaer',
  GE: 'Generali',
  GK: 'GVV Privatversicherung',
  GP: 'GVV Privatversicherung',
  HA: 'HUK Allgemeine (nicht-öffentlicher Dienst)',
  HC: 'HUK-Coburg (öffentlicher Dienst)',
  HD: 'HDI / Mercedes Benz Versicherung',
  HG: 'HDI / Mercedes Benz Versicherung',
  HE: 'Helvetia',
  HH: 'Hanse Merkur',
  HU: 'HUK24',
  JA: 'Janitos',
  JV: 'Volkswagen Autoversicherung',
  KA: 'Kravag Allgemeine',
  KL: 'Kravag Logistic',
  KQ: 'ERGO',
  LV: 'LVM',
  MA: 'Mannheimer',
  ME: 'Mecklenburgische',
  MH: 'ÖSA Versicherung',
  MV: 'Münchener Verein',
  N2: 'Nürnberger',
  NX: 'Nexible',
  PR: 'Provinzial Rheinland',
  PV: 'Provinzial Nord Brandkasse',
  R1: 'RheinLand Versicherung',
  R5: 'Rhion',
  RD: 'R+V Direktversicherung / R+V24',
  RV: 'R+V',
  S0: 'Sparkassen Direktversicherung',
  SD: 'Sparkassen Direktversicherung',
  SF: 'Saarland Feuerversicherung',
  SH: 'Itzehoer / Admiral Direkt',
  SU: 'Signal Iduna',
  SV: 'Sparkassenversicherung',
  UV: 'Universa',
  V0: 'VHV',
  VB: 'Volkswohl-Bund',
  VS: 'Allsecur',
  VT: 'Verti',
  W1: 'Württembergische Gemeinde-Versicherung / WGV Himmelblau',
  W2: 'WGV - Schwäbische Allgemeine',
  WQ: 'Westfälische Provinzial',
  WV: 'Württembergische Versicherung',
  WW: 'WWK',
  Z1: 'Zurich',
};

/**
 * Returns true if the value is not empty
 *
 * @params {String} val
 * @returns {Boolean}
 */
validator.extend('required', val => {
  if (_.isObject(val)) {
    return !_.isEmpty(val);
  } else {
    return !validator.isNull(val);
  }
});
//!validator.isNull(val)

/**
 * Returns true if the value is boolean true
 *
 * @params {String} val
 * @returns {Boolean}
 */
validator.extend('isChecked', val => {
  // compare it against string representation of a bool value, because
  // validator ensures all incoming values are coerced to strings
  // https://github.com/chriso/validator.js#strings-only
  return val === 'true';
});

/**
 * Returns true if the value is greater than or equal
 *
 * @params {String} val
 * @params {Number} min
 * @returns {Boolean}
 */
validator.extend('isGreaterThanOrEqual', (val, min) => {
  return val >= min;
});

validator.extend('isUrl', val => {
  return validator.isURL(val, { require_protocol: true });
});

/**
 * Electronic insurance number (EIN) validation
 * https://www.evb-nummer.com/zusammensetzung-der-evb-nummer/
 * If the value is empty or not defined the validator returns true
 */
validator.extend('isEIN', val => {
  if (!val) {
    return true;
  }

  return (
    _.isString(val) && val.length === 7 && new RegExp('^[a-z0-9]+$', 'i').test(val) && INSURER_KEYS[val.substr(0, 2)]
  );
});

validator.extend('isIban', val => {
  return IBAN.isValid(val);
});

export default validator;
